export default __webpack_public_path__ + "static/media/SD-ganapathi-homam-banner-img.cdbdb0db.png";